import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { flatten2dh4kibw1u0qq as flatten } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { await3gx2tubo6ckuc as await_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { PlatformUtils_getInstance3hk77c3xwk5zt as PlatformUtils_getInstance } from '../../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { GMTDate36bhedawynxlf as GMTDate } from '../../../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import {
  get_WEBSOCKETS_KEY4y3dps3lzl71 as get_WEBSOCKETS_KEY,
  WebSocketCapability_instancerfowbrsc2s1e as WebSocketCapability_instance,
  WebSocketExceptionb5mwyitzck0i as WebSocketException,
} from '../../plugins/websocket/WebSockets.mjs';
import { JsWebSocketSession2h93x4rgbt7zw as JsWebSocketSession } from '../../plugins/websocket/JsWebSocketSession.mjs';
import { CancellationExceptionjngvjj221x3v as CancellationException } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Exceptions.mjs';
import {
  cancel2en0dn4yvpufo as cancel,
  get_job2zvlvce9o9a29 as get_job,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Companion_getInstance37paccmlttr9s as Companion_getInstance,
  headersOf2tgdoojg8tifn as headersOf,
} from '../../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import {
  Companion_getInstance2192nrpo98q6y as Companion_getInstance_0,
  HttpStatusCode3o1wkms10pg4k as HttpStatusCode,
} from '../../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { Companion_getInstance222gjh8cwt6g7 as Companion_getInstance_1 } from '../../../../../../ktor-ktor-http/io/ktor/http/HttpProtocolVersion.mjs';
import {
  HttpResponseData2dozo5khuplr6 as HttpResponseData,
  isUpgradeRequest3msdo2i9hxs68 as isUpgradeRequest,
  get_ResponseAdapterAttributeKey1ll13ywinsgvd as get_ResponseAdapterAttributeKey,
} from '../../request/HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from '../HttpClientEngineBase.mjs';
import { HttpTimeoutCapability_instance26tgzga341tse as HttpTimeoutCapability_instance } from '../../plugins/HttpTimeout.mjs';
import { SSECapability_instance2ef4zov329xco as SSECapability_instance } from '../../plugins/sse/SSE.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals_0,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { callContext1e7m0cguk0p07 as callContext } from '../Utils.mjs';
import { get_CLIENT_CONFIG1oazdiwjd1qe0 as get_CLIENT_CONFIG } from '../HttpClientEngine.mjs';
import {
  ktor_toRaw2rfi0vr7xajpw as ktor_toRaw,
  asStringm4998zsa7g15 as asString,
} from '../../utils/JsUtils.js.mjs';
import { Companion_getInstancevamc1em5et0c as Companion_getInstance_2 } from '../../JsRequestUtils.mjs';
import {
  commonFetch9qseoz65108t as commonFetch,
  readBody4gczno2wau05 as readBody,
} from './compatibility/Utils.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { dropCompressionHeaders12falb2m2fkr1 as dropCompressionHeaders } from '../../utils/HeadersUtils.mjs';
import { buildHeaders3beu05fiq9iq2 as buildHeaders } from '../../utils/headers.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { arrayConcat3qsij7vh68m69 as arrayConcat } from '../../../../../../kotlin-kotlin-stdlib/noPackageHacks.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *createWebSocket($this, urlString_capturingHack, headers, $completion) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = headers.u4p();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (equals(element, 'Sec-WebSocket-Protocol', true)) {
      destination.i2(element);
    }
  }
  var protocolHeaderNames = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = protocolHeaderNames.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp0_safe_receiver = headers.t4p(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.i2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = flatten(destination_0);
  var protocols = copyToArray(this_0);
  var tmp;
  if (PlatformUtils_getInstance().f4p_1) {
    tmp = new WebSocket(urlString_capturingHack, protocols);
  } else {
    var ws_import = import('ws');
    var ws_capturingHack = (yield* await_0(ws_import, $completion)).default;
    var headers_capturingHack = new (JsClientEngine$createWebSocket$headers_capturingHack$1())();
    headers.z4p((name, values) => {
      headers_capturingHack[name] = joinToString(values, ',');
      return Unit_instance;
    });
    tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
  }
  return tmp;
}
function *executeWebSocketRequest($this, request, callContext, $completion) {
  var requestTime = GMTDate();
  var urlString = request.j5l_1.toString();
  var wsConfig = request.o5l_1.j4n(get_WEBSOCKETS_KEY());
  var socket = yield* /*#__NOINLINE__*/createWebSocket($this, urlString, request.l5l_1, $completion);
  var session = new (JsWebSocketSession())(callContext, socket, wsConfig.y5t_1);
  try {
    yield* awaitConnection(socket, $completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      cancel(callContext, CancellationException('Failed to connect to ' + urlString, cause));
      throw cause;
    } else {
      throw $p;
    }
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = socket.protocol;
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_0) > 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var protocol = tmp;
  var headers = !(protocol == null) ? headersOf('Sec-WebSocket-Protocol', protocol) : Companion_getInstance().c51_1;
  return new (HttpResponseData())(Companion_getInstance_0().t52_1, requestTime, headers, Companion_getInstance_1().l52_1, session, callContext);
}
function JsClientEngine$execute$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var JsClientEngine$createWebSocket$headers_capturingHack$1Class;
function JsClientEngine$createWebSocket$headers_capturingHack$1() {
  if (JsClientEngine$createWebSocket$headers_capturingHack$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    JsClientEngine$createWebSocket$headers_capturingHack$1Class = $;
  }
  return JsClientEngine$createWebSocket$headers_capturingHack$1Class;
}
var JsClientEngineClass;
function JsClientEngine() {
  if (JsClientEngineClass === VOID) {
    class $ extends HttpClientEngineBase() {
      constructor(config) {
        super('ktor-js');
        this.h5x_1 = config;
        this.i5x_1 = setOf([HttpTimeoutCapability_instance, WebSocketCapability_instance, SSECapability_instance]);
        // Inline function 'kotlin.check' call
        if (!(this.h5x_1.e5m_1 == null)) {
          var message = 'Proxy unsupported in Js engine.';
          throw IllegalStateException().o(toString(message));
        }
      }
      v5g() {
        return this.h5x_1;
      }
      q5l() {
        return this.i5x_1;
      }
      *z5l(data, $completion) {
        var callContext_0 = yield* callContext($completion);
        var clientConfig = data.o5l_1.j4n(get_CLIENT_CONFIG());
        if (isUpgradeRequest(data)) {
          return yield* /*#__NOINLINE__*/executeWebSocketRequest(this, data, callContext_0, $completion);
        }
        var requestTime = GMTDate();
        var rawRequest = yield* ktor_toRaw(data, clientConfig, callContext_0, $completion);
        var tmp0_safe_receiver = data.o5l_1.k4n(Companion_getInstance_2().r5w_1);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s5w_1;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          tmp = JsClientEngine$execute$lambda;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var fetchOptions = tmp;
        var rawResponse = yield* commonFetch(data.j5l_1.toString(), rawRequest, fetchOptions, this.h5x_1, get_job(callContext_0), $completion);
        var status = new (HttpStatusCode())(rawResponse.status, rawResponse.statusText);
        var headers = mapToKtor(rawResponse.headers, data.k5l_1, data.o5l_1);
        var version = Companion_getInstance_1().l52_1;
        var body = readBody(CoroutineScope(callContext_0), rawResponse);
        var tmp2_safe_receiver = data.o5l_1.k4n(get_ResponseAdapterAttributeKey());
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w5u(data, status, headers, body, data.m5l_1, callContext_0);
        var responseBody = tmp3_elvis_lhs == null ? body : tmp3_elvis_lhs;
        return new (HttpResponseData())(status, requestTime, headers, version, responseBody, callContext_0);
      }
    }
    initMetadataForClass($, 'JsClientEngine', VOID, VOID, VOID, [1, 2]);
    JsClientEngineClass = $;
  }
  return JsClientEngineClass;
}
function mapToKtor(_this__u8e3s4, method, attributes) {
  return buildHeaders(($this$buildHeaders) => {
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.forEach((value, key) => {
      $this$buildHeaders.x4p(key, value);
      return Unit_instance;
    });
    dropCompressionHeaders($this$buildHeaders, method, attributes, PlatformUtils_getInstance().f4p_1);
    return Unit_instance;
  });
}
function *awaitConnection(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.z10();
    $l$block: {
      var continuation = cancellable;
      if (continuation.yw()) {
        break $l$block;
      }
      // Inline function 'io.ktor.client.utils.addEventListener' call
      var this_0 = _this__u8e3s4;
      var events = ['error'];
      var once = true;
      var events_0 = listOf(arrayConcat([['open'], events]));
      var callback = {_v: null};
      var tmp = () => {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = events_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp;
          if (callback._v == null) {
            throwUninitializedPropertyAccessException('callback');
          } else {
            tmp = callback._v;
          }
          this_0.removeEventListener(element, tmp);
        }
        return Unit_instance;
      };
      var disposable = new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp);
      callback._v = (event) => {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        if (once) {
          disposable.sz();
        }
        var tmp0_subject = event.type;
        if (tmp0_subject === 'open') {
          var tmp0 = continuation;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = _this__u8e3s4;
          var tmp$ret$13 = _Result___init__impl__xyqfz8(value);
          tmp0.rc(tmp$ret$13);
        } else if (tmp0_subject === 'error') {
          var tmp0_0 = continuation;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = WebSocketException().t5t(asString(event));
          var tmp$ret$15 = _Result___init__impl__xyqfz8(createFailure(exception));
          tmp0_0.rc(tmp$ret$15);
        }
        return Unit_instance;
      };
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = events_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_0;
        if (callback._v == null) {
          throwUninitializedPropertyAccessException('callback');
        } else {
          tmp_0 = callback._v;
        }
        this_0.addEventListener(element, tmp_0);
      }
      var disposable_0 = disposable;
      continuation.hz((cause) => {
        disposable_0.sz();
        var tmp;
        if (!(cause == null)) {
          _this__u8e3s4.close();
          tmp = Unit_instance;
        }
        return Unit_instance;
      });
    }
    return cancellable.jy();
  };
}
var sam$kotlinx_coroutines_DisposableHandle$0Class;
function sam$kotlinx_coroutines_DisposableHandle$0() {
  if (sam$kotlinx_coroutines_DisposableHandle$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.j5x_1 = function_0;
      }
      sz() {
        return this.j5x_1();
      }
      i5() {
        return this.j5x_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, DisposableHandle()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals_0(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle(), FunctionAdapter()]);
    sam$kotlinx_coroutines_DisposableHandle$0Class = $;
  }
  return sam$kotlinx_coroutines_DisposableHandle$0Class;
}
//region block: exports
export {
  JsClientEngine as JsClientEngine2d6599fsx5fyf,
};
//endregion

//# sourceMappingURL=JsClientEngine.mjs.map
